import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, setPersistence, browserLocalPersistence} from "firebase/auth";
import { getFirestore, collection } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaEnterpriseProvider, getToken} from "firebase/app-check";
import { getFunctions, httpsCallable } from "firebase/functions";


const firebaseConfig = {
  
  apiKey: import.meta.env.VITE_APIKEY,
  authDomain: import.meta.env.VITE_AUTHDOMAIN,
  projectId: import.meta.env.VITE_PROJECTID,
  storageBucket: import.meta.env.VITE_STORAGEBUCKET,
  messagingSenderId: import.meta.env.VITE_MESSAGINGSENDERID,
  appId: import.meta.env.VITE_FIREBASE_APPID,
};

// FIREBASE APP
const app = initializeApp(firebaseConfig);
const appCheck = initializeAppCheck(app, {provider: new ReCaptchaEnterpriseProvider(import.meta.env.VITE_RECAPTCHA_ENTERPRISE_SITE_KEY), isTokenAutoRefreshEnabled: true});
getToken(appCheck, false)
  .then(({ token }) => {})
  .catch(error => {console.error("App Check hiba:", error);});
const database = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const authReady = await setPersistence(auth, browserLocalPersistence);
const functions = getFunctions(app, "us-central1");

let refList = {}
refList.USERSREF = collection(database, 'users');
refList.INVENTORYREF = collection(database, 'inventory');
refList.CITIESREF = collection(database, 'cities');
refList.CITYUSERSREF = collection(database, 'cityusers');
refList.LOGSREF = collection(database, 'logs');
refList.TERAREF = collection(database, 'tera');

const waitForAuth = () => {
    return new Promise((resolve) => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            unsubscribe();
            resolve(user);
        });
    });
};

export { app, auth, database, storage, refList, waitForAuth, functions };